import { z } from 'zod';
/**
 * Perto de Mim (estudos de 23/10/2026: Páginas Amarelas aprovado e o desenho com as decisões
 * do Igor). O catálogo dos negócios da cidade: a base aberta (Overture, licença CDLA
 * Permissive 2.0) fica num arquivo que a API carrega na memória; no banco ficam só as
 * correções, as denúncias de número errado e os lugares guardados de cada pessoa.
 */
export const PERTO_GROUPS = [
    'saude',
    'beleza',
    'casa',
    'comida',
    'lojas',
    'carro',
    'pets',
    'servicos',
];
export const pertoGroupSchema = z.enum(PERTO_GROUPS);
export const PERTO_GROUP_INFO = {
    saude: { label: 'Saúde', icon: '/perto/saude.webp' },
    beleza: { label: 'Beleza', icon: '/perto/beleza.webp' },
    casa: { label: 'Casa e reparos', icon: '/perto/casa.webp' },
    comida: { label: 'Comida', icon: '/perto/comida.webp' },
    lojas: { label: 'Lojas', icon: '/perto/lojas.webp' },
    carro: { label: 'Carro', icon: '/perto/carro.webp' },
    pets: { label: 'Pets', icon: '/perto/pets.webp' },
    servicos: { label: 'Serviços', icon: '/perto/servicos.webp' },
};
/**
 * As subcategorias (taxonomia de 29/10, `apps/api/scripts/places/taxonomia.py`): a pílula de cada
 * categoria, com ícone de porcelana próprio em `public/perto/sub/<chave>.webp`. O lugar leva a
 * subcategoria (`sub`) e a especialidade exata no rótulo ("Cardiologia" em Especialistas).
 * "outros_*" usa o ícone da categoria; "empresas" (fábrica, distribuidor, escritório) só aparece
 * na busca pelo nome, nunca navegando.
 */
export const PERTO_SUBS = {
    dentista: { group: 'saude', label: 'Dentista' },
    farmacia: { group: 'saude', label: 'Farmácia' },
    medico: { group: 'saude', label: 'Médicos e clínicas' },
    especialistas: { group: 'saude', label: 'Especialistas' },
    hospital: { group: 'saude', label: 'Hospital e pronto-socorro' },
    exames: { group: 'saude', label: 'Exames e laboratórios' },
    psicologia: { group: 'saude', label: 'Psicologia e terapia' },
    fisioterapia: { group: 'saude', label: 'Fisioterapia' },
    olhos: { group: 'saude', label: 'Oftalmologia' },
    mulher: { group: 'saude', label: 'Saúde da mulher' },
    pediatria: { group: 'saude', label: 'Pediatria' },
    dermatologia: { group: 'saude', label: 'Dermatologia e plástica' },
    terapias: { group: 'saude', label: 'Terapias integrativas' },
    nutricao: { group: 'saude', label: 'Nutrição' },
    idosos: { group: 'saude', label: 'Cuidado de idosos' },
    academia: { group: 'saude', label: 'Academia' },
    personal: { group: 'saude', label: 'Personal trainer' },
    pilates: { group: 'saude', label: 'Pilates' },
    ioga: { group: 'saude', label: 'Ioga e meditação' },
    lutas: { group: 'saude', label: 'Lutas e artes marciais' },
    danca: { group: 'saude', label: 'Dança' },
    outros_saude: { group: 'saude', label: 'Outros em saúde' },
    salao: { group: 'beleza', label: 'Salão de beleza' },
    cabelo: { group: 'beleza', label: 'Cabeleireiro' },
    barbearia: { group: 'beleza', label: 'Barbearia' },
    unhas: { group: 'beleza', label: 'Manicure e pedicure' },
    sobrancelhas: { group: 'beleza', label: 'Sobrancelhas e cílios' },
    estetica: { group: 'beleza', label: 'Estética' },
    depilacao: { group: 'beleza', label: 'Depilação' },
    maquiagem: { group: 'beleza', label: 'Maquiagem' },
    spa: { group: 'beleza', label: 'Spa' },
    massagem: { group: 'beleza', label: 'Massagem' },
    tatuagem: { group: 'beleza', label: 'Tatuagem e piercing' },
    bronzeamento: { group: 'beleza', label: 'Bronzeamento' },
    cosmeticos: { group: 'beleza', label: 'Cosméticos e perfumaria' },
    outros_beleza: { group: 'beleza', label: 'Outros em beleza' },
    eletricista: { group: 'casa', label: 'Eletricista' },
    encanador: { group: 'casa', label: 'Encanador' },
    pintor: { group: 'casa', label: 'Pintor' },
    pedreiro: { group: 'casa', label: 'Pedreiro e reforma' },
    gesseiro: { group: 'casa', label: 'Gesseiro' },
    arcondicionado: { group: 'casa', label: 'Ar-condicionado' },
    eletrodomesticos: { group: 'casa', label: 'Conserto de eletrodomésticos' },
    chaveiro: { group: 'casa', label: 'Chaveiro' },
    serralheiro: { group: 'casa', label: 'Serralheiro' },
    montador: { group: 'casa', label: 'Montador' },
    impermeabilizacao: { group: 'casa', label: 'Impermeabilização' },
    limpeza: { group: 'casa', label: 'Limpeza' },
    dedetizacao: { group: 'casa', label: 'Dedetização' },
    piscina: { group: 'casa', label: 'Piscinas' },
    jardinagem: { group: 'casa', label: 'Jardinagem' },
    lavanderia: { group: 'casa', label: 'Lavanderia' },
    costura: { group: 'casa', label: 'Costura e ajustes' },
    vidracaria: { group: 'casa', label: 'Vidraçaria' },
    marcenaria: { group: 'casa', label: 'Marcenaria' },
    solar: { group: 'casa', label: 'Energia solar' },
    seguranca: { group: 'casa', label: 'Segurança eletrônica' },
    projetos: { group: 'casa', label: 'Arquitetura e engenharia' },
    moveis: { group: 'casa', label: 'Móveis' },
    colchoes: { group: 'casa', label: 'Colchões' },
    construcao: { group: 'casa', label: 'Material de construção' },
    ferragens: { group: 'casa', label: 'Ferragens' },
    tintas: { group: 'casa', label: 'Tintas' },
    iluminacao: { group: 'casa', label: 'Iluminação' },
    eletro: { group: 'casa', label: 'Eletrodomésticos' },
    utilidades: { group: 'casa', label: 'Utilidades e decoração' },
    outros_casa: { group: 'casa', label: 'Outros para casa' },
    restaurante: { group: 'comida', label: 'Restaurantes' },
    brasileira: { group: 'comida', label: 'Comida brasileira' },
    selfservice: { group: 'comida', label: 'Self-service' },
    pizzaria: { group: 'comida', label: 'Pizzaria' },
    hamburgueria: { group: 'comida', label: 'Hamburgueria' },
    churrascaria: { group: 'comida', label: 'Churrascaria' },
    japonesa: { group: 'comida', label: 'Japonesa' },
    italiana: { group: 'comida', label: 'Italiana' },
    frutos_do_mar: { group: 'comida', label: 'Frutos do mar' },
    frango: { group: 'comida', label: 'Frango' },
    saudavel: { group: 'comida', label: 'Saudável' },
    lanchonete: { group: 'comida', label: 'Lanchonete' },
    fastfood: { group: 'comida', label: 'Fast food' },
    cachorro_quente: { group: 'comida', label: 'Cachorro-quente' },
    bar: { group: 'comida', label: 'Bares' },
    cervejaria: { group: 'comida', label: 'Cervejaria' },
    noite: { group: 'comida', label: 'Música e noite' },
    padaria: { group: 'comida', label: 'Padaria' },
    doceria: { group: 'comida', label: 'Doces e bolos' },
    chocolateria: { group: 'comida', label: 'Chocolateria' },
    sorveteria: { group: 'comida', label: 'Sorveteria' },
    acai: { group: 'comida', label: 'Açaí' },
    cafeteria: { group: 'comida', label: 'Cafeteria' },
    sucos: { group: 'comida', label: 'Sucos' },
    cha: { group: 'comida', label: 'Chás' },
    mercado: { group: 'comida', label: 'Mercado' },
    hortifruti: { group: 'comida', label: 'Hortifruti' },
    peixaria: { group: 'comida', label: 'Peixaria' },
    acougue: { group: 'comida', label: 'Açougue' },
    emporio: { group: 'comida', label: 'Empório' },
    adega: { group: 'comida', label: 'Adega e bebidas' },
    conveniencia: { group: 'comida', label: 'Conveniência' },
    naturais: { group: 'comida', label: 'Produtos naturais' },
    suplementos: { group: 'comida', label: 'Suplementos' },
    delivery: { group: 'comida', label: 'Delivery' },
    foodtruck: { group: 'comida', label: 'Food truck' },
    outros_comida: { group: 'comida', label: 'Outros em comida' },
    roupas: { group: 'lojas', label: 'Roupas' },
    feminina: { group: 'lojas', label: 'Moda feminina' },
    masculina: { group: 'lojas', label: 'Moda masculina' },
    infantil: { group: 'lojas', label: 'Moda infantil' },
    intima: { group: 'lojas', label: 'Moda íntima e praia' },
    noivas: { group: 'lojas', label: 'Noivas e festa' },
    calcados: { group: 'lojas', label: 'Calçados' },
    bolsas: { group: 'lojas', label: 'Bolsas e acessórios' },
    joalheria: { group: 'lojas', label: 'Joias e relógios' },
    otica: { group: 'lojas', label: 'Ótica' },
    celulares: { group: 'lojas', label: 'Celulares' },
    eletronicos: { group: 'lojas', label: 'Eletrônicos' },
    informatica: { group: 'lojas', label: 'Informática' },
    esportes: { group: 'lojas', label: 'Esportes' },
    bicicletas: { group: 'lojas', label: 'Bicicletas' },
    livraria: { group: 'lojas', label: 'Livraria' },
    instrumentos: { group: 'lojas', label: 'Instrumentos musicais' },
    papelaria: { group: 'lojas', label: 'Papelaria' },
    brinquedos: { group: 'lojas', label: 'Brinquedos' },
    festa: { group: 'lojas', label: 'Artigos de festa' },
    artesanato: { group: 'lojas', label: 'Artesanato e tecidos' },
    floricultura: { group: 'lojas', label: 'Floricultura' },
    presentes: { group: 'lojas', label: 'Presentes' },
    brecho: { group: 'lojas', label: 'Brechó e antiquário' },
    departamento: { group: 'lojas', label: 'Departamento e variedades' },
    shopping: { group: 'lojas', label: 'Shopping' },
    outros_lojas: { group: 'lojas', label: 'Outras lojas' },
    oficina: { group: 'carro', label: 'Oficina mecânica' },
    funilaria: { group: 'carro', label: 'Funilaria e vidros' },
    estetica_auto: { group: 'carro', label: 'Estética automotiva' },
    lavajato: { group: 'carro', label: 'Lava-jato' },
    pneus: { group: 'carro', label: 'Pneus e borracharia' },
    posto: { group: 'carro', label: 'Posto de combustível' },
    autopecas: { group: 'carro', label: 'Autopeças' },
    concessionaria: { group: 'carro', label: 'Concessionária' },
    motos: { group: 'carro', label: 'Motos' },
    aluguel_carro: { group: 'carro', label: 'Aluguel de carros' },
    outros_carro: { group: 'carro', label: 'Outros para o carro' },
    petshop: { group: 'pets', label: 'Pet shop' },
    veterinario: { group: 'pets', label: 'Veterinário' },
    banho_tosa: { group: 'pets', label: 'Banho e tosa' },
    hospedagem_pet: { group: 'pets', label: 'Hotel e passeio' },
    outros_pets: { group: 'pets', label: 'Outros para pets' },
    escola: { group: 'servicos', label: 'Escolas' },
    educacao_infantil: { group: 'servicos', label: 'Educação infantil' },
    faculdade: { group: 'servicos', label: 'Faculdade' },
    cursos: { group: 'servicos', label: 'Cursos e aulas' },
    idiomas: { group: 'servicos', label: 'Idiomas' },
    autoescola: { group: 'servicos', label: 'Autoescola' },
    advocacia: { group: 'servicos', label: 'Advocacia' },
    cartorio: { group: 'servicos', label: 'Cartório e despachante' },
    contabilidade: { group: 'servicos', label: 'Contabilidade' },
    financas: { group: 'servicos', label: 'Finanças e crédito' },
    seguros: { group: 'servicos', label: 'Seguros e planos' },
    imobiliaria: { group: 'servicos', label: 'Imobiliária' },
    hotel: { group: 'servicos', label: 'Hotel e pousada' },
    viagens: { group: 'servicos', label: 'Viagens e turismo' },
    eventos: { group: 'servicos', label: 'Festas e eventos' },
    fotografia: { group: 'servicos', label: 'Fotografia' },
    grafica: { group: 'servicos', label: 'Gráfica' },
    marketing: { group: 'servicos', label: 'Marketing e publicidade' },
    conserto_tech: { group: 'servicos', label: 'Assistência técnica' },
    internet: { group: 'servicos', label: 'Internet e TV' },
    correios: { group: 'servicos', label: 'Correios e envios' },
    transporte: { group: 'servicos', label: 'Táxi e transporte' },
    aluguel: { group: 'servicos', label: 'Aluguel' },
    lazer: { group: 'servicos', label: 'Lazer e cultura' },
    loterica: { group: 'servicos', label: 'Lotérica' },
    outros_servicos: { group: 'servicos', label: 'Outros serviços' },
    empresas: { group: 'servicos', label: 'Empresas' },
};
export const PERTO_SUB_KEYS = Object.keys(PERTO_SUBS);
export const pertoSubSchema = z.enum(PERTO_SUB_KEYS);
/** Subcategoria que não vira pílula nem atalho (o resto da categoria e as empresas). */
export const isPertoCatchAll = (sub) => sub.startsWith('outros_') || sub === 'empresas';
/** O ícone da subcategoria; "outros" e subcategoria desconhecida usam o da categoria. */
export function pertoIcon(item) {
    const sub = item.sub;
    if (!sub || isPertoCatchAll(sub) || !(sub in PERTO_SUBS))
        return PERTO_GROUP_INFO[item.group].icon;
    return `/perto/sub/${sub}.webp`;
}
/**
 * Quanto o telefone foi conferido. "aberto": veio de um cadastro público, de uma fonte só; o
 * número não aparece no perfil (pedido do Igor: só mostrar telefone conferido), mas o
 * Secretário ainda prepara a mensagem pelo WhatsApp de quem pediu. "conferido": pessoas
 * confirmaram que é do negócio. "dono": o dono assumiu o perfil.
 */
export const PHONE_LEVELS = ['aberto', 'conferido', 'dono'];
export const phoneLevelSchema = z.enum(PHONE_LEVELS);
/** Confirmações de "é esse o número" que tornam o telefone conferido. */
export const PHONE_CONFIRMS_NEEDED = 3;
export const pertoPlaceSchema = z.object({
    id: z.string().min(1).max(64),
    name: z.string().min(1).max(120),
    group: pertoGroupSchema,
    label: z.string().min(1).max(60),
    /** A subcategoria (PERTO_SUBS); o rótulo é a especialidade exata. */
    sub: z.string().max(40),
    address: z.string().max(160),
    city: z.string().max(60),
    /** Nulos nos negócios do Secretário sem posição no mapa (o endereço continua valendo). */
    lat: z.number().nullable(),
    lon: z.number().nullable(),
    /** Em metros, quando a busca tem a posição de quem procura. */
    distance: z.number().int().nonnegative().nullable(),
    phoneLevel: phoneLevelSchema.nullable(),
    /** Só quando conferido ou do dono. */
    phone: z.string().max(20).nullable(),
    /** Os quatro últimos dígitos, para "não é esse número?" sem expor o resto. */
    phoneEnd: z.string().max(4).nullable(),
    site: z.string().max(300).nullable(),
    social: z.string().max(300).nullable(),
    /** O dono já está no Secretário (assumiu o perfil). */
    onSec: z.boolean(),
    ownerVerified: z.boolean(),
    /** Tem página aprovada na vitrine do bairro (`/v/<id>`, produtos e preços). */
    vitrine: z.boolean().optional(),
    /** O que a vitrine diz que o lugar vende (até três linhas curtas), para os cartões. */
    offer: z.array(z.string().max(80)).max(3).optional(),
    /** Autônomo do cadastro aberto do CNPJ (ofício pelo CNAE declarado); pode pedir para sair. */
    registry: z.boolean().optional(),
    /** Pessoas diferentes que chamaram pelo Secretário (Meus profissionais); só a partir de 5. */
    secServices: z.number().int().optional(),
    saved: z.boolean(),
    /** Negócio que está no Secretário: conversa direto, vitrine e página da clínica. */
    sec: z
        .object({
        username: z.string(),
        chat: z.boolean(),
        shop: z.boolean(),
        clinicSlug: z.string().nullable(),
    })
        .nullable()
        .optional(),
});
/**
 * Ordem da lista (estudo de 29/10). Só o que a base sabe de verdade: sem nota, preço ou
 * tempo de entrega inventados. "perto" precisa da posição de quem procura.
 */
export const PERTO_SORTS = ['relevancia', 'perto', 'nome'];
export const pertoSortSchema = z.enum(PERTO_SORTS);
export const PERTO_SORT_LABEL = {
    relevancia: 'Mais relevantes',
    perto: 'Mais perto',
    nome: 'Nome (A a Z)',
};
/** Filtros da lista: cada um é um fato conferido, não uma promessa. */
export const PERTO_FILTERS = ['vitrine', 'conferido', 'secretario', 'autonomo'];
export const pertoFilterSchema = z.enum(PERTO_FILTERS);
export const PERTO_FILTER_LABEL = {
    vitrine: 'Com vitrine',
    conferido: 'Telefone conferido',
    secretario: 'Conversa no Secretário',
    autonomo: 'Profissional autônomo',
};
export const pertoSearchQuerySchema = z.object({
    q: z.string().trim().max(80).optional(),
    group: pertoGroupSchema.optional(),
    /** A subcategoria (chave de PERTO_SUBS, como "farmacia"). */
    sub: z.string().trim().min(1).max(40).optional(),
    sort: pertoSortSchema.default('relevancia'),
    filter: pertoFilterSchema.optional(),
    lat: z.coerce.number().min(-90).max(90).optional(),
    lon: z.coerce.number().min(-180).max(180).optional(),
    limit: z.coerce.number().int().min(1).max(30).default(20),
    /** "Mostrar mais": quantos já vieram. */
    offset: z.coerce.number().int().min(0).max(600).default(0),
});
export const pertoSearchResultSchema = z.object({
    places: z.array(pertoPlaceSchema),
    /** Total que bateu com a busca antes do corte. */
    total: z.number().int().nonnegative(),
    /** A posição de quem procura está onde a rede já chegou (fora dela, o app oferece o pedido da cidade). */
    covered: z.boolean(),
    /**
     * Quando a busca é um pedido reconhecido ("eletricista"), quantos são exatamente isso; eles vêm
     * primeiro e o resto só tem o nome parecido. Nulo quando a busca é por nome.
     */
    exact: z.number().int().nonnegative().nullable(),
    /** Créditos da base aberta, mostrados no rodapé (exigência da licença). */
    attribution: z.string(),
});
/** As vitrines e atalhos da página (Perto de Mim e cada categoria). */
export const pertoOverviewQuerySchema = z.object({
    group: pertoGroupSchema.optional(),
    lat: z.coerce.number().min(-90).max(90).optional(),
    lon: z.coerce.number().min(-180).max(180).optional(),
});
export const pertoSubcategorySchema = z.object({
    sub: z.string(),
    label: z.string(),
    group: pertoGroupSchema,
    /** Quantos lugares com esse rótulo (perto de quem procura, quando há posição). */
    count: z.number().int().nonnegative(),
});
export const pertoOverviewSchema = z.object({
    /** As subcategorias com mais opções (na categoria, ou em toda a rede). */
    subcategories: z.array(pertoSubcategorySchema),
    /**
     * Os pedidos mais buscados nos últimos 30 dias; vazio enquanto a contagem não tem volume
     * (a tela mostra "Atalhos" com as subcategorias, sem fingir que são as mais buscadas).
     */
    popular: z.array(pertoSubcategorySchema),
    /** O que a pessoa abriu por último ("Últimas lojas"). */
    recent: z.array(pertoPlaceSchema),
    /** "Porque você viu Farmácia": outros do mesmo tipo, perto, que ela ainda não abriu. */
    forYou: z
        .object({ sub: z.string(), label: z.string(), places: z.array(pertoPlaceSchema) })
        .nullable(),
    /** Lugares com vitrine aprovada (produtos e preços), os mais perto primeiro. */
    vitrine: z.array(pertoPlaceSchema),
    /** Negócios que estão no Secretário (conversa direta). */
    sec: z.array(pertoPlaceSchema),
    /** Quantos lugares a categoria (ou a rede) tem. */
    total: z.number().int().nonnegative(),
    /** A posição de quem procura está onde a rede já chegou. */
    covered: z.boolean(),
});
/** "sair": a própria pessoa (autônomo do cadastro aberto) pede para sair da lista. */
export const PERTO_REPORT_KINDS = ['numero_errado', 'fechou', 'golpe', 'outro', 'sair'];
/** Golpe (G6): o lugar sai do Perto quando pessoas diferentes avisam, nunca por um aviso só. */
export const PERTO_SCAM_HIDE = 3;
export const pertoReportSchema = z.object({
    kind: z.enum(PERTO_REPORT_KINDS),
    note: z.string().trim().max(300).optional(),
});
export const PERTO_ATTRIBUTION = 'Dados de lugares © Overture Maps Foundation (CDLA Permissive 2.0)';
/**
 * Como as pessoas pedem, ligado ao rótulo da base: "cabelo" acha salão e barbearia, "remédio"
 * acha farmácia. Cada linha: o jeito de falar e os rótulos (ou grupos) que ele procura.
 */
export const PERTO_SYNONYMS = [
    ['cabelo', ['Salão de beleza', 'Cabeleireiro', 'Barbearia']],
    ['corte de cabelo', ['Cabeleireiro', 'Barbearia', 'Salão de beleza']],
    ['barba', ['Barbearia']],
    ['unha', ['Manicure e pedicure', 'Salão de beleza']],
    ['manicure', ['Manicure e pedicure']],
    ['sobrancelha', ['Sobrancelhas e cílios', 'Salão de beleza']],
    ['estetica', ['Estética', 'Spa']],
    ['remedio', ['Farmácia']],
    ['dentista', ['Dentista', 'Ortodontia']],
    ['medico', ['Consultório médico', 'Clínica', 'Clínica geral', 'Especialidade médica']],
    ['exame', ['Laboratório', 'Exames e laboratórios']],
    ['psicologo', ['Psicologia']],
    ['fisio', ['Fisioterapia']],
    ['academia', ['Academia', 'Treino funcional', 'Pilates']],
    ['personal', ['Personal trainer', 'Academia', 'Treino funcional']],
    ['pizza', ['Pizzaria']],
    ['hamburguer', ['Hamburgueria']],
    ['lanche', ['Lanchonete', 'Hamburgueria', 'Fast food']],
    ['sushi', ['Sushi', 'Comida japonesa']],
    ['japones', ['Comida japonesa', 'Sushi']],
    ['acai', ['Açaí']],
    ['pao', ['Padaria']],
    ['bolo', ['Doces e bolos', 'Doceria', 'Padaria']],
    ['doce', ['Doceria', 'Chocolateria', 'Doces']],
    ['sorvete', ['Sorveteria']],
    ['cafe', ['Cafeteria', 'Café', 'Padaria']],
    ['almoco', ['Restaurante', 'Self-service', 'Comida brasileira']],
    ['churrasco', ['Churrascaria']],
    ['mercado', ['Mercado', 'Mercado e empório', 'Hortifruti']],
    ['cerveja', ['Adega', 'Bar', 'Cervejaria']],
    ['roupa', ['Loja de roupas', 'Moda feminina', 'Moda masculina', 'Moda']],
    ['vestido', ['Moda feminina', 'Loja de roupas', 'Moda']],
    ['sapato', ['Calçados']],
    ['tenis', ['Calçados', 'Esportes']],
    ['oculos', ['Ótica']],
    ['celular', ['Celulares', 'Eletrônicos', 'Informática']],
    ['computador', ['Informática']],
    ['presente', ['Presentes', 'Floricultura', 'Acessórios']],
    ['flor', ['Floricultura', 'Presentes']],
    ['eletricista', ['Eletricista']],
    ['luz', ['Eletricista']],
    ['encanador', ['Encanador']],
    ['vazamento', ['Encanador']],
    ['chaveiro', ['Chaveiro']],
    ['ar condicionado', ['Ar-condicionado']],
    ['piscina', ['Piscinas']],
    ['faxina', ['Limpeza']],
    ['diarista', ['Limpeza']],
    ['pedreiro', ['Pedreiro', 'Empreiteiro', 'Construção e reforma']],
    ['gesso', ['Gesseiro']],
    ['gesseiro', ['Gesseiro']],
    ['serralheiro', ['Serralheiro']],
    ['serralheria', ['Serralheiro']],
    ['portao', ['Serralheiro']],
    ['montador', ['Montador de móveis', 'Montador e instalador']],
    ['montar movel', ['Montador de móveis']],
    ['infiltracao', ['Impermeabilização']],
    ['impermeabilizacao', ['Impermeabilização']],
    ['eletrodomestico', ['Conserto de eletrodomésticos']],
    ['reforma', ['Construção e reforma', 'Empreiteiro', 'Pintor']],
    ['pintor', ['Pintor']],
    ['jardineiro', ['Jardineiro', 'Jardinagem']],
    ['marceneiro', ['Marcenaria']],
    ['moveis', ['Móveis', 'Marcenaria']],
    ['material de construcao', ['Material de construção', 'Ferragens']],
    ['geladeira', ['Conserto de eletrodomésticos']],
    ['maquina de lavar', ['Conserto de eletrodomésticos']],
    ['dedetizacao', ['Dedetização']],
    ['mudanca', ['Mudanças']],
    ['vidro', ['Vidraçaria']],
    ['costura', ['Costura e ajustes']],
    ['mecanico', ['Oficina mecânica', 'Oficina e serviços']],
    ['oficina', ['Oficina mecânica', 'Oficina de motos', 'Funilaria e pintura']],
    ['pneu', ['Borracharia e pneus']],
    ['lavar carro', ['Lava-jato', 'Estética automotiva']],
    ['gasolina', ['Posto de combustível']],
    ['moto', ['Oficina de motos', 'Motos']],
    ['pet', ['Pet shop', 'Veterinário', 'Banho e tosa']],
    ['cachorro', ['Pet shop', 'Veterinário', 'Banho e tosa']],
    ['gato', ['Pet shop', 'Veterinário']],
    ['veterinario', ['Veterinário']],
    ['advogado', ['Advocacia', 'Serviços jurídicos']],
    ['contador', ['Contabilidade']],
    ['seguro', ['Seguros']],
    ['imovel', ['Imobiliária', 'Corretor de imóveis', 'Administradora de imóveis']],
    ['festa', ['Festas e eventos', 'Artigos de festa', 'Espaço de eventos']],
    ['grafica', ['Gráfica']],
    ['ingles', ['Escola de idiomas']],
    ['autoescola', ['Autoescola']],
    ['hotel', ['Hotel', 'Pousada', 'Hospedagem']],
    ['lavanderia', ['Lavanderia']],
];
/** "Quero o Sec em {cidade}": o pedido de quem está fora da rede. */
export const pertoCityDemandSchema = z.object({
    city: z.string().trim().min(2).max(80),
    state: z
        .string()
        .trim()
        .regex(/^[A-Za-z]{2}$/)
        .optional(),
});
